import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagDisabled: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-disabled',
		defaultMessage: '‘{displayName}’ is off',
		description: 'Text that indicates how many feature flags there are.',
	},
	flagWithoutPercentage: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-without-percentage',
		defaultMessage: '‘{displayName}’ is on',
		description: 'Text that indicates how many feature flags there are.',
	},
	flagWithPercentage: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-with-percentage',
		defaultMessage: '‘{displayName}’ is on at {percentage, number, percent}',
		description: 'Text that indicates how many feature flags there are.',
	},
	flagPercentageRollout: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.flag-percentage-rollout',
		defaultMessage: '{featureFlagPercentageRollout, number, percent}',
		description: 'Rollout percentage of feature flag.',
	},
});
